// 若报错：Could not find a declaration file for module '@lingui/message-utils/compileMessage'. 
// 解决方法：在 tsconfig.json 中[添加/修改]以下配置：
// "compilerOptions": {
//     ...
//     "lib": [ ..., "esnext" ],
//     "module": "esnext", // esnext
//     "moduleResolution": "bundler", // node16 || nodenext || bundler
//     ...
// }
import { compileMessage } from "@lingui/message-utils/compileMessage";
import { i18n, Messages } from "@lingui/core";
import cookie from 'react-cookies'; // npm i --save-dev @types/react-cookies
import { Cookie_Keys_Enum } from "./Common/CommonEnum";


export const locales = {
    zh: `简体中文`,
    en: "English"
};

// The default locale to activate
export const defaultLocale: string = "zh";

// CRA mark all resources which are not JS as 'asset/resource'
// Since we don't have access to the webpack config here is a dirty
// way to avoid this limitation.
// CRA将所有非JS的资源标记为“资产/资源”
// 因为我们无法访问webpack配置，所以这里很脏
// 避免这种限制的方法。
// https://github.com/webpack/webpack/pull/10097#issuecomment-567116011

// Unfortunately this workaround dosent work with dynamic loading
// so we have to explicitly enumerate all catalogs here.
// 不幸的是，这种解决方法不适用于动态加载
// 所以我们必须在这里明确地枚举所有目录。
const catalogs: Record<string, () => Promise<Messages>> = {
    zh: async () => {
        const messages = await import(/* @ts-ignore */
            `./file.js!=!@lingui/loader!./locales/zh.po`
        );
        return messages;
    },
    en: async () => {
        const { messages } = await import(/* @ts-ignore */
            `./file.js!=!@lingui/loader!./locales/en.po`
        );
        return messages;
    }
};

/**
 * We do a dynamic import of just the catalog that we need
 * 我们只动态导入所需的目录
 * @param locale any locale string
 */
export async function dynamicActivate(locale: string) {
    /* 方式一：使用 @lingui/loader 加载po文件，但生产环境下会报错，因为找不到js文件。 */
    // const messages = await catalogs[locale as any]();
    /* 方式二：直接读取编译后的js文件 */
    const { messages } = await import(`./locales/${locale}.js`);
    i18n.setMessagesCompiler(compileMessage);
    i18n.loadAndActivate({ locale, messages });
    console.log("language activate: ", locale);
}

// If not we can just load all the catalogs and do a simple i18n.active(localeToActive)
// 如果不是，我们可以加载所有目录并执行一个简单的 i18n.active(localeToActive)
// i18n.load({
//   zh: messagesZh,
//   en: messagesEn,
// });

/**
 * 拉取当前语言设置。
 * @returns {string} language
 */
export function getLanguage() {
    return cookie.load(Cookie_Keys_Enum.language) || defaultLocale;
}
